import { AppBadgesType, type AppBadge } from '@wix/app-market-services';

export function hasBenefitOrBundleBadge({
  appBadges,
}: {
  appBadges: AppBadge[];
}): boolean {
  return appBadges.some(
    (badge) =>
      badge.badge === AppBadgesType.APP_BENEFIT ||
      badge.badge === AppBadgesType.PREMIUM_BENEFIT,
  );
}
